import React from 'react';
import './homepage.css';
import HeroSection from '../../components/heroSection/HeroSection';
import Skills from '../../components/skills/Skills';
import LmuSection from '../../components/lmuSection/LmuSection';
import MathSkill from '../../components/mathSkill/mathSkill';
import Courses from '../../components/courses/Courses';
import ProjectSection from '../../components/projectsSection/ProjectSection';
import Interests from '../../components/interests/Interests';
import Contact from '../../components/contact/Contact';
import Engineering3DComponent from '../../components/engineeringModel/EngineeringModel';
import EducationSection from '../../components/educationSection/EducationSection';
import VideoProject from '../../components/videoProject/VideoProject';


const Homepage = () => {
  return (
    <div className='homepage'>
        <HeroSection />
        <EducationSection />
        <Skills />
        <MathSkill />  
        <Courses />
        <VideoProject />
        <Contact />
    </div>
  )
}

export default Homepage;
